import { createContext, useContext } from 'react';

// Everything the finance pages need that comes from the host. Set once by <FinanceApp>.
export const FinanceContext = createContext({
  vertical: 'car_rental',
  // When the module is embedded in a single vertical's admin app, every list/queue is scoped to
  // that vertical (a jewelry admin never sees car_rental / real_estate rows) and the "Vertical"
  // filter is hidden. null in the standalone console, where the whole point is a platform-wide view.
  scopedVertical: null,
  wording: {},
  actorRole: null,
  canApproveFinance: false, // finance_lead / finance_manager / admin — unifies the old
                            // canActOnRefunds / canActOnPayables split
  canEditConfig: false,     // admin / finance_manager
  isAdmin: false,
  onOpenExternal: null      // (kind, entity) => void — the rare jump back into the host app
});

export function useFinance() {
  return useContext(FinanceContext);
}

export const APPROVE_ROLES = ['finance_lead', 'finance_manager', 'admin'];
export const EDIT_ROLES = ['finance_manager', 'admin'];
